import { render } from "./ResetPasswordSuccess.vue?vue&type=template&id=4a027ee0&scoped=true&ts=true"
import script from "./ResetPasswordSuccess.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordSuccess.vue?vue&type=script&lang=ts"

import "./ResetPasswordSuccess.vue?vue&type=style&index=0&id=4a027ee0&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a027ee0"]])

export default __exports__